export const InstagramIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="36" rx="18" fill="url(#paint0_linear_2_7)" />
    <rect
      x="8"
      y="8"
      width="20"
      height="20"
      rx="4"
      stroke="white"
      strokeWidth="2"
    />
    <circle cx="18" cy="18" r="4" stroke="white" strokeWidth="2" />
    <circle cx="24" cy="12" r="1" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_2_7"
        x1="18"
        y1="0"
        x2="18"
        y2="36"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8A0FB6" />
        <stop offset="0.479167" stopColor="#D60B54" />
        <stop offset="1" stopColor="#F3A611" />
      </linearGradient>
    </defs>
  </svg>
);
